import { useState } from "react"
import { CommonExportButton } from "./CommonExportButton"
import { ExportModal, type ExportModalProps } from "./ExportModal"

export const MultipleExportsButton = (
  props: Omit<ExportModalProps, "open" | "onClose">,
) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <CommonExportButton title="Exports" onClick={() => setOpen(true)} />
      <ExportModal {...props} open={open} onClose={() => setOpen(false)} />
    </>
  )
}
